import React from 'react';
import styled, { keyframes } from 'styled-components';

type ShimmerLoaderProps = {
  height?: number;
  width?: number;
  margin?: string | number;
};

const ShimmerAnimation = keyframes`
  100% {
    -webkit-mask-position: left;
  }
`;

const ShimmerBox = styled.div<ShimmerLoaderProps>`
  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300%
    100%;
  mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%;
  background-repeat: no-repeat;
  animation: ${ShimmerAnimation} 2.5s infinite;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) =>
    height ? `${height}px` : 'var(--cc_size_spacing_l)'};
  margin: ${({ margin }) => `${margin} !important` || '0'};
  margin-bottom: var(--cc_size_spacing_xs);
  background-color: var(--cc_color_background_3);
`;

function ShimmerLoader({ height, margin, width }: ShimmerLoaderProps) {
  return <ShimmerBox height={height} margin={margin} width={width} />;
}

export default ShimmerLoader;
